import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { forwardRef } from 'react';
import { useStyles, StyleSheet } from '@rexlabs/styling';
import { useOverlay } from './context';
var defaultStyles = StyleSheet({
  container: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: function backgroundColor(_ref) {
      var token = _ref.token;
      return token('color.overlay.default');
    }
  }
});
export var Backdrop = /*#__PURE__*/forwardRef(function Backdrop(_, ref) {
  var s = useStyles(defaultStyles);

  var _useOverlay = useOverlay(),
      overlays = _useOverlay.overlays;

  return /*#__PURE__*/React.createElement("div", _extends({}, s.with('container')({
    zIndex: overlays.length * 50
  }), {
    ref: ref
  }));
});